import { render, staticRenderFns } from "./MoverCategory.vue?vue&type=template&id=a3fda724&"
import script from "./MoverCategory.vue?vue&type=script&lang=js&"
export * from "./MoverCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports